import React from 'react';
import { useDispatch } from 'react-redux';
import { filterDeliveryDonwload } from '../../actions/deliveryNotes';
import { storeStartLoading } from '../../actions/storeCrud';

import moment from 'moment';

export const BtnDeliveryDonwload = (props) => {

    const dispatch = useDispatch();
    const date = moment().format("yyyy-MM-DD");
    let dateWeek = moment();
    const intervalMovement = window.APP_CONFIG.daymovement;
    dateWeek = dateWeek.subtract(intervalMovement, "days");
    dateWeek = dateWeek.format("yyyy-MM-DD");

    const deliverynNotes = {
        store_id: props.store !== undefined ? props.store :'',
        sdate: dateWeek,
        edate: date,
        narticle: '',
        ean: '',
        sscc: '',
        ordercode: '',
        deliverynote: '',
        providercode: '',
    }

    const handleClick = () => {
        dispatch(storeStartLoading());
        dispatch(filterDeliveryDonwload(deliverynNotes));
    }

    return (
        <button className="btn btn-danger margin_right_envelope btnColor" props={props} onClick={handleClick}>
            <i className="fas fa-user-alt icon"></i>
            <span className="navbar-brand user">
                DESCARGAS
            </span>
        </button>
    )
}
